import React from 'react' // eslint-disable-line no-unused-vars
const Error = () =>
  <div className='row widget-mb-0-row'>
    <div className='col'>
      <div className='container'>
        <div>
          <div className='row'>
            <div className='col-12 col-xl-12'>
              <h3 className='mb-3'>
                <i className='sli-shield m-r-10' />Page Not Found
              </h3>
              <p>This page doesn't exist, please click on the button below to go back to the homepage.</p>
            </div>
            <div className='col-xl-2 col-lg-4'>
              <a className='btn btn-primary m-r-10 btn-icon' href='/'>
                <i className='sli-action-undo' />Return to the Homepage
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
export default Error



// WEBPACK FOOTER //
// ./src/mi-app/Error.js